const disconnect = async (
  network: 'solana' | 'ethereum' | 'base' | 'arbitrum' | 'bnb' | 'optimism', // Supporting all networks
  setHistory: React.Dispatch<React.SetStateAction<string[]>>,
  setConnectedNetwork: React.Dispatch<React.SetStateAction<'solana' | 'ethereum' | 'base' | 'arbitrum' | 'bnb' | 'optimism' | null>> // SetStateAction should allow null as well
): Promise<string[]> => {
  try {
    if (network === 'solana' && window.solana?.isPhantom) {
      // Disconnect Solana wallet
      if (window.solana?.disconnect) {
        await window.solana.disconnect();
        setConnectedNetwork(null); // Set network to null after disconnecting
        return ['Solana wallet disconnected successfully.'];
      } else {
        return ['⚠ Solana wallet disconnect method not available.'];
      }
    } else if (network === 'ethereum' || network === 'base' || network === 'arbitrum' || network === 'bnb' || network === 'optimism') {
      // Handle EVM-based networks (Ethereum, Base, Arbitrum, BNB, Optimism)
      if (window.ethereum) {
        // Clear the connected network for all EVM-based networks
        setConnectedNetwork(null);
        return [`${network.charAt(0).toUpperCase() + network.slice(1)} wallet disconnected successfully.`];
      } else {
        return ['⚠ No Ethereum wallet detected. Please ensure your wallet is connected.'];
      }
    } else {
      return ['⚠ Unsupported network or wallet not connected.'];
    }
  } catch (err) {
    return ['⚠ Failed to disconnect wallet.'];
  }
};

export default disconnect;
